(() => {
  const cards = document.querySelectorAll('[data-ingnok-product-card]');
  if (!cards.length) return;

  const root = window.Shopify?.routes?.root || '/';
  const safeHandle = value => /^[a-z0-9][a-z0-9-]*$/.test(String(value || '')) ? String(value) : '';

  async function presentmentCurrency() {
    try {
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
      if (response.ok) return (await response.json()).currency || 'USD';
    } catch (_) {
      // The product response still provides a price when cart currency is unavailable.
    }
    return window.Shopify?.currency?.active || 'USD';
  }

  function formatPrice(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency
    }).format(Number(cents || 0) / 100);
  }

  async function hydrate(card, currency) {
    const handle = safeHandle(card.dataset.productHandle);
    if (!handle) return;

    try {
      const response = await fetch(`${root}products/${handle}.js`, { credentials: 'same-origin' });
      if (!response.ok) return;
      const product = await response.json();
      const variant = product.variants?.find(item => item.available) || product.variants?.[0];
      if (!variant) return;

      const price = card.querySelector('[data-ingnok-product-price]');
      if (price) {
        const availablePrices = product.variants.filter(item => item.available).map(item => item.price);
        const hasRange = availablePrices.length > 1 && new Set(availablePrices).size > 1;
        price.textContent = `${hasRange ? 'From ' : ''}${formatPrice(variant.price, currency)}`;
        price.hidden = false;
      }

      const addToCart = card.querySelector('[data-ingnok-product-add]');
      if (addToCart && variant.available) {
        addToCart.href = `${root}cart/${variant.id}:1`;
        addToCart.hidden = false;
      }
    } catch (_) {
      // Preserve the truthful product-details fallback without exposing stale price or variant data.
    }
  }

  presentmentCurrency().then(currency => cards.forEach(card => hydrate(card, currency)));
})();
